import { Body1 } from '@sainsburys-tech/luna-typography'
import { IIncidentInvolved } from '../../../types'
import { formatCurrency } from '../../../utils/formatCurrency'

const IncidentInvolved = ({ totalPeople, totalVehicles, affectedProducts }: IIncidentInvolved) => {

  let totalValue = 0
  let totalAmount = 0

  if(affectedProducts.length > 0) {
    affectedProducts.forEach(product => {
      totalAmount = totalAmount + product.quantity
      totalValue = (product.value * product.quantity) + totalValue
    });
  }

  const formattedTotalValue = formatCurrency(totalValue.toString())

  return (
    <>
      <div  className='s-incident-report-padding'>
        { totalPeople > 0 ?
          <div>
            <Body1
              className="ln-u-color-dark"
            >
              { totalPeople > 1 ? (totalPeople + " people involved.") : (totalPeople + " person involved.") }
            </Body1>
          </div> : ''
        }
        { totalVehicles > 0 ?
          <div>
            <Body1
              className="ln-u-color-dark"
            >
              { totalVehicles > 1 ? (totalVehicles + " vehicles involved.") : (totalVehicles + " vehicle involved.") }
            </Body1>
          </div> : ''
        }
        { totalAmount > 0 ?
          <div>
            <Body1
              className="ln-u-color-dark"
            >
              { totalAmount > 1 ? `${totalAmount} products involved worth ${formattedTotalValue}.` : `${totalAmount} product involved worth ${formattedTotalValue}.` }
            </Body1>
          </div> : ''
        }
      </div>
    </>
  )
}

export default IncidentInvolved